/*! @pentacode/ui v0.1.0 */
import { t as e } from "./styledElement-Dm1irIE2.js";
import { t } from "./decorateMetadata-BhwOl-pv.js";
import { t as n } from "./decorate-DHgd5sZx.js";
import { t as r } from "./css-build-DICbZE45.js";
import { LitElement as i, html as a } from "lit";
import { customElement as o, property as s, query as c } from "lit/decorators.js";
//#endregion
//#region \0lit-plugin:css-sheet:./src/elements/assistant/assistant-spinner/assistant-spinner.css.js
var l = r(":host{display:block}canvas{height:var(--assistant-spinner-height,4rem);aspect-ratio:1;width:auto;display:block}"), u = 256, d = 75, f = 1.05, p = -.35, m = .25, h = u / 2, g = u / 2;
function _(e) {
	let t = e.replace("#", "");
	return [
		parseInt(t.slice(0, 2), 16) || 0,
		parseInt(t.slice(2, 4), 16) || 0,
		parseInt(t.slice(4, 6), 16) || 0
	];
}
function v(e, t) {
	return [
		Math.max(0, Math.min(255, e[0] + t)),
		Math.max(0, Math.min(255, e[1] + t)),
		Math.max(0, Math.min(255, e[2] + t))
	];
}
function y(e) {
	return [
		v(e, -45),
		v(e, -25),
		e,
		v(e, 15),
		v(e, 25)
	];
}
function b(e) {
	return [
		e,
		v(e, -20),
		v(e, 15),
		v(e, -10)
	];
}
function x(e) {
	return [
		e,
		v(e, -16),
		v(e, -6),
		v(e, 4),
		v(e, -26)
	];
}
function S(e) {
	let t = e * m, n = Math.cos(f), r = Math.sin(f), i = Math.cos(p), a = Math.sin(p), o = Math.cos(t), s = Math.sin(t);
	return function(e, t, c, l) {
		let u = e * o + c * s, d = -e * s + c * o, f = t * n - d * r, p = t * r + d * n, m = u * i - f * a, _ = u * a + f * i, v = 300 / (300 + p);
		return {
			x: h + m * v,
			y: g + l + _ * v,
			z: p,
			scale: v
		};
	};
}
var C;
function w(e, t, n, r) {
	return C(Math.cos(e) * t, r, Math.sin(e) * t, n);
}
function T(e, t, n, r, i) {
	let a = Math.cos(e) * t, o = Math.sin(e) * t, s = r, c = Math.cos(i), l = Math.sin(i), u = s * c - o * l, d = s * l + o * c;
	return C(a, u, d, n);
}
function E(e, t) {
	let n = Math.sin(e * 127.1 + t * 311.7) * 43758.5453;
	return n - Math.floor(n);
}
function D(e, t) {
	let n = Math.floor(e), r = e - n, i = r * r * (3 - 2 * r);
	return E(n, t) * (1 - i) + E(n + 1, t) * i;
}
var O = class {
	constructor(e, t, n, r, i) {
		this._radius = e.radius, this._peaks = e.peaks, this._amp = e.amp, this._speed = e.speed, this._rotSpeed = e.rotSpeed, this._yOffset = e.yOffset, this._width = e.width * i, this._blur = e.blur * i, this._phase = e.phase, this._fadeSpeed = e.fadeSpeed, this._seed = e.seed, this._greenSplash = e.greenSplash, this._orbitTilt = e.orbitTilt, this.color = n, this.accentColor = r, this._pad = Math.ceil(this._blur * 3), this._offW = u + this._pad * 2, this._offH = u + this._pad * 2, this._offCanvas = document.createElement("canvas"), this._offCanvas.width = this._offW * t, this._offCanvas.height = this._offH * t, this._offCtx = this._offCanvas.getContext("2d"), this._offCtx.setTransform(t, 0, 0, t, 0, 0);
	}
	render(e) {
		let t = e * this._speed + this._phase, n = e * this._rotSpeed, r = Math.PI * 2 / 180, i = this._offCtx;
		i.clearRect(0, 0, this._offW, this._offH), i.save(), i.filter = `blur(${this._blur}px)`, i.lineWidth = this._width, i.lineCap = "round", i.lineJoin = "round";
		let a = .4 + .6 * Math.abs(Math.sin(e * this._fadeSpeed)), [o, s, c] = this.color;
		i.translate(this._pad, this._pad);
		let l = .6 + .4 * Math.sin(e * .4 + this._seed) + Math.max(0, Math.sin(e * 1.7 + this._seed * 3)) ** 4 * .6;
		for (let u = 0; u < 2; u++) {
			i.beginPath();
			let d = !1;
			for (let a = 0; a <= 180; a++) {
				let o = a * r, s = o + n, c = Math.round(s * this._peaks / (Math.PI * 2) % this._peaks), f = .3 + D(e * .8 + c * 7.3, this._seed + c) * 1.4, p = Math.abs(Math.sin(s * this._peaks / 2 + t)) ** 1.5, m = -(this._amp * p * l * f + Math.sin(s * 37 + t * 4) * this._amp * .04 * l), h = this._orbitTilt === 0 ? w(o, this._radius, this._yOffset, m) : T(o, this._radius, this._yOffset, m, this._orbitTilt), g = h.z > 0;
				if (u === 0 && !g || u === 1 && g) {
					d = !1;
					continue;
				}
				d ? i.lineTo(h.x, h.y) : (i.moveTo(h.x, h.y), d = !0);
			}
			i.strokeStyle = `rgba(${o},${s},${c},${u === 0 ? .25 * a : .9 * a})`, i.stroke();
		}
		if (this._greenSplash) {
			let o = Math.max(0, Math.sin(e * 1.3 + this._seed * 2)) ** 2, s = Math.max(0, Math.sin(e * .9 + this._seed * 5 + 1.5)) ** 2, c = Math.max(o, s);
			if (c > .03) {
				i.beginPath();
				let o = !1;
				for (let a = 0; a <= 180; a++) {
					let s = a * r, c = s + n, u = Math.abs(Math.sin(c * this._peaks / 2 + t)) ** 1.5;
					if (u < .25) {
						o = !1;
						continue;
					}
					let d = Math.round(c * this._peaks / (Math.PI * 2) % this._peaks), f = .3 + D(e * .8 + d * 7.3, this._seed + d) * 1.4, p = -(this._amp * u * l * f), m = this._orbitTilt === 0 ? w(s, this._radius, this._yOffset, p) : T(s, this._radius, this._yOffset, p, this._orbitTilt);
					if (m.z > 0) {
						o = !1;
						continue;
					}
					o ? i.lineTo(m.x, m.y) : (i.moveTo(m.x, m.y), o = !0);
				}
				let [s, u, d] = this.accentColor;
				i.strokeStyle = `rgba(${s},${u},${d},${c * .85 * a})`, i.lineWidth = this._width * .7, i.stroke();
			}
		}
		i.restore();
	}
	stamp(e) {
		e.drawImage(this._offCanvas, 0, 0, this._offCanvas.width, this._offCanvas.height, -this._pad, -this._pad, this._offW, this._offH);
	}
}, k = class {
	constructor(e, t, n) {
		this._radius = e.radius, this._orbitSpeed = e.orbitSpeed, this._bobSpeed = e.bobSpeed, this._bobAmp = e.bobAmp, this._driftRadius = e.driftRadius, this._size = e.size, this._fadeSpeed = e.fadeSpeed, this._angle = e.startAngle, this._yOffset = e.yOffset, this._seed = e.seed, this.colorIndex = e.colorIndex, this.isPrimary = e.isPrimary, this.color = t, this.thickness = n;
	}
	draw(e, t) {
		let n = this._angle + t * this._orbitSpeed, r = Math.sin(t * .6 + this._seed * 5) * this._driftRadius, i = this._radius + r, a = Math.sin(t * this._bobSpeed + this._seed * 3) * this._bobAmp, o = w(n, i, this._yOffset, a), s = (o.z > 0 ? .2 : 1) * (.3 + .7 * (.5 + .5 * Math.sin(t * this._fadeSpeed + this._seed))), c = this._size * this.thickness * (.7 + .3 * Math.sin(t * 2.5 + this._seed * 7)) * o.scale, [l, u, d] = this.color;
		e.save(), e.shadowColor = `rgba(${l},${u},${d},${s * .8})`, e.shadowBlur = c * 4, e.beginPath(), e.arc(o.x, o.y, Math.max(.3, c), 0, Math.PI * 2), e.fillStyle = `rgba(${l},${u},${d},${s})`, e.fill(), e.restore();
	}
}, A = [
	{
		radius: d * 1.08,
		peaks: 5,
		amp: 12,
		speed: .6,
		rotSpeed: .08,
		yOffset: -8,
		width: 10,
		blur: 10,
		phase: 0,
		fadeSpeed: .15,
		seed: 1,
		greenSplash: !0,
		orbitTilt: 0
	},
	{
		radius: d * 1.04,
		peaks: 5,
		amp: 14,
		speed: .8,
		rotSpeed: .12,
		yOffset: -8,
		width: 6,
		blur: 6,
		phase: .5,
		fadeSpeed: .2,
		seed: 2,
		greenSplash: !0,
		orbitTilt: 0
	},
	{
		radius: d,
		peaks: 5,
		amp: 16,
		speed: 1,
		rotSpeed: .15,
		yOffset: -8,
		width: 3.5,
		blur: 3,
		phase: 0,
		fadeSpeed: .3,
		seed: 3,
		greenSplash: !0,
		orbitTilt: 0
	},
	{
		radius: d * .96,
		peaks: 5,
		amp: 13,
		speed: 1.3,
		rotSpeed: -.1,
		yOffset: -8,
		width: 2.5,
		blur: 1.5,
		phase: 1.2,
		fadeSpeed: .35,
		seed: 4,
		greenSplash: !0,
		orbitTilt: 0
	},
	{
		radius: d * .99,
		peaks: 5,
		amp: 15,
		speed: 1.05,
		rotSpeed: .14,
		yOffset: -8,
		width: 2,
		blur: 1,
		phase: .2,
		fadeSpeed: .28,
		seed: 5,
		greenSplash: !0,
		orbitTilt: 0
	}
], j = [
	{
		radius: d * 1.04,
		peaks: 5,
		amp: 14,
		speed: .8,
		rotSpeed: .12,
		yOffset: -8,
		width: 4,
		blur: 4,
		phase: 0,
		fadeSpeed: .2,
		seed: 1,
		greenSplash: !0,
		orbitTilt: 0
	},
	{
		radius: d * 1.04,
		peaks: 5,
		amp: 14,
		speed: .8,
		rotSpeed: .12,
		yOffset: -8,
		width: 4,
		blur: 4,
		phase: .5,
		fadeSpeed: .2,
		seed: 2,
		greenSplash: !0,
		orbitTilt: Math.PI * 2 / 3
	},
	{
		radius: d * 1.04,
		peaks: 5,
		amp: 14,
		speed: .8,
		rotSpeed: .12,
		yOffset: -8,
		width: 4,
		blur: 4,
		phase: 1,
		fadeSpeed: .2,
		seed: 3,
		greenSplash: !0,
		orbitTilt: -(Math.PI * 2) / 3
	}
];
function M() {
	let e = [];
	for (let t = 0; t < 8; t++) e.push({
		radius: d * (.85 + Math.random() * .35),
		orbitSpeed: (.15 + Math.random() * .25) * (Math.random() > .5 ? 1 : -1),
		bobSpeed: 1 + Math.random() * 2,
		bobAmp: 3 + Math.random() * 10,
		driftRadius: 5 + Math.random() * 12,
		size: 1.2 + Math.random() * 2,
		colorIndex: t % 4,
		isPrimary: !0,
		fadeSpeed: .4 + Math.random() * .8,
		startAngle: t / 8 * Math.PI * 2 + Math.random() * .5,
		yOffset: -8,
		seed: t * 3.7
	});
	for (let t = 0; t < 14; t++) e.push({
		radius: d * (.82 + Math.random() * .4),
		orbitSpeed: (.1 + Math.random() * .35) * (Math.random() > .5 ? 1 : -1),
		bobSpeed: 1 + Math.random() * 2.5,
		bobAmp: 3 + Math.random() * 14,
		driftRadius: 4 + Math.random() * 12,
		size: 1 + Math.random() * 2.2,
		colorIndex: t % 5,
		isPrimary: !1,
		fadeSpeed: .4 + Math.random() * 1,
		startAngle: t / 14 * Math.PI * 2 + Math.random() * .8,
		yOffset: -8,
		seed: 200 + t * 4.1
	});
	for (let t = 0; t < 6; t++) {
		let n = t % 2 == 0;
		e.push({
			radius: d * (1.25 + Math.random() * .3),
			orbitSpeed: (.05 + Math.random() * .12) * (Math.random() > .5 ? 1 : -1),
			bobSpeed: .5 + Math.random(),
			bobAmp: 2 + Math.random() * 6,
			driftRadius: 8 + Math.random() * 15,
			size: .8 + Math.random() * 1.2,
			colorIndex: 0,
			isPrimary: !n,
			fadeSpeed: .2 + Math.random() * .4,
			startAngle: t / 6 * Math.PI * 2 + Math.random(),
			yOffset: -8,
			seed: 50 + t * 5.3
		});
	}
	for (let t = 0; t < 10; t++) {
		let n = t % 2 == 0;
		e.push({
			radius: d * (.92 + Math.random() * .16),
			orbitSpeed: (.4 + Math.random() * .5) * (Math.random() > .5 ? 1 : -1),
			bobSpeed: 3 + Math.random() * 3,
			bobAmp: 1 + Math.random() * 4,
			driftRadius: 2 + Math.random() * 6,
			size: .5 + Math.random() * .8,
			colorIndex: n ? 0 : 2,
			isPrimary: !n,
			fadeSpeed: 1 + Math.random() * 1.5,
			startAngle: Math.random() * Math.PI * 2,
			yOffset: -8,
			seed: 100 + t * 2.1
		});
	}
	return e;
}
var N = M(), P = class extends e(i) {
	constructor(...e) {
		super(...e), this.styles = l, this.speed = 2, this.primaryColor = "#c3e7f5", this.accentColor = "#e2ff41", this.thickness = 2, this.atomOrbit = !1, this.paused = !1, this._animationId = null, this._rings = [], this._particles = [], this._initialized = !1;
	}
	render() {
		return a`<canvas part="canvas"></canvas>`;
	}
	firstUpdated() {
		this._activate();
	}
	updated(e) {
		e.has("paused") && (this.paused ? this._stopAnimation() : this._activate()), this._initialized && (e.has("thickness") || e.has("atomOrbit") ? this._rebuildObjects() : (e.has("primaryColor") || e.has("accentColor")) && this._applyColors());
	}
	connectedCallback() {
		super.connectedCallback(), this._handleVisibilityChange = this._handleVisibilityChange.bind(this), document.addEventListener("visibilitychange", this._handleVisibilityChange);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this._animationId !== null && (cancelAnimationFrame(this._animationId), this._animationId = null), document.removeEventListener("visibilitychange", this._handleVisibilityChange);
	}
	_handleVisibilityChange() {
		document.hidden ? this._stopAnimation() : this._activate();
	}
	_activate() {
		this.paused || (this._initialized ||= (this._setupCanvas(), !0), this._startAnimation());
	}
	_applyColors() {
		let e = _(this.primaryColor), t = _(this.accentColor), n = y(e);
		for (let e = 0; e < this._rings.length; e++) {
			let r = this._rings[e], i = n[e];
			r && i && (r.color = i, r.accentColor = t);
		}
		let r = b(e), i = x(t);
		for (let e of this._particles) if (e.isPrimary) {
			let t = r[e.colorIndex % r.length];
			t && (e.color = t);
		} else {
			let t = i[e.colorIndex % i.length];
			t && (e.color = t);
		}
	}
	_rebuildObjects() {
		if (!this._canvas) return;
		let e = window.devicePixelRatio || 1, t = _(this.primaryColor), n = _(this.accentColor), r = y(t), i = b(t), a = x(n), o = this.atomOrbit ? j : A;
		this._rings = o.map((t, i) => {
			let a = r[i % r.length];
			if (!a) throw Error(`Missing ring color at index ${i}`);
			return new O(t, e, a, n, this.thickness);
		}), this._particles = N.map((e) => {
			let t = e.isPrimary ? i : a, n = t[e.colorIndex % t.length];
			if (!n) throw Error(`Missing particle color at index ${e.colorIndex}`);
			return new k(e, n, this.thickness);
		});
	}
	_setupCanvas() {
		let e = this._canvas;
		if (!e) return;
		let t = window.devicePixelRatio || 1;
		e.width = u * t, e.height = u * t;
		let n = e.getContext("2d");
		n && n.setTransform(t, 0, 0, t, 0, 0);
		let r = _(this.primaryColor), i = _(this.accentColor), a = y(r), o = b(r), s = x(i), c = this.atomOrbit ? j : A;
		this._rings = c.map((e, n) => {
			let r = a[n % a.length];
			if (!r) throw Error(`Missing ring color at index ${n}`);
			return new O(e, t, r, i, this.thickness);
		}), this._particles = N.map((e) => {
			let t = e.isPrimary ? o : s, n = t[e.colorIndex % t.length];
			if (!n) throw Error(`Missing particle color at index ${e.colorIndex}`);
			return new k(e, n, this.thickness);
		});
	}
	_startAnimation() {
		if (this.paused || this._animationId !== null) return;
		let e = this._canvas;
		if (!e) return;
		let t = e.getContext("2d");
		if (!t) return;
		let n = window.devicePixelRatio || 1, r = (e) => {
			let i = e * .001 * this.speed;
			C = S(i), t.setTransform(n, 0, 0, n, 0, 0), t.clearRect(0, 0, u, u);
			for (let e of this._rings) e.render(i), e.stamp(t);
			for (let e of this._particles) e.draw(t, i);
			this._animationId = requestAnimationFrame(r);
		};
		this._animationId = requestAnimationFrame(r);
	}
	_stopAnimation() {
		this._animationId !== null && (cancelAnimationFrame(this._animationId), this._animationId = null);
	}
};
n([s({ type: Number }), t("design:type", Object)], P.prototype, "speed", void 0), n([s({ type: String }), t("design:type", Object)], P.prototype, "primaryColor", void 0), n([s({ type: String }), t("design:type", Object)], P.prototype, "accentColor", void 0), n([s({ type: Number }), t("design:type", Object)], P.prototype, "thickness", void 0), n([s({ type: Boolean }), t("design:type", Object)], P.prototype, "atomOrbit", void 0), n([s({ type: Boolean }), t("design:type", Object)], P.prototype, "paused", void 0), n([c("canvas"), t("design:type", typeof HTMLCanvasElement > "u" ? Object : HTMLCanvasElement)], P.prototype, "_canvas", void 0), P = n([o("ptc-ui-assistant-spinner")], P);
//#endregion
export { P as t };

//# sourceMappingURL=assistant-spinner-BUAMbZE6.js.map